import { t } from '@lingui/core/macro';
import { BooleanFilter } from './BooleanFilter';
export const activeFilterLabel = () => t({ message: 'Active', comment: 'Insights: Active filter' });
export function ActiveFilter() {
    return <BooleanFilter name="metadataDocumentActive" label={activeFilterLabel()}/>;
}
